'use strict';

const { toggleInvalidFor, isNewPasswordConfirmed } = require('../profile/formValidationsUtils');

$('body').on('newPassword:valid', function () {
    validateForm();
});

/**
 * Reset Password page Validation function
 */
function validateForm() {
    const $submitUpdatedPasswordBtn = $('.submit-new-password');
    const isvalidPassword = $('.new-password').closest('.input-group').hasClass('valid');
    const isPasswordConfirmed = isNewPasswordConfirmed();
    if (isvalidPassword && isPasswordConfirmed) {
        $submitUpdatedPasswordBtn.removeAttr('disabled');
    } else {
        $submitUpdatedPasswordBtn.attr('disabled', 'disabled');
    }
}

const $newConfirmedPassword = $('.new-password-confirm');
$newConfirmedPassword.keyup(function () {
    validateForm();
    toggleInvalidFor($newConfirmedPassword, isNewPasswordConfirmed());
});
